import React from "react";
import AuthService from "@/services/AuthService";
export const AuthContext = React.createContext(AuthService);
